"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildOptionSummaryRowId = exports.buildOptionId = exports.buildOptionHeaderId = exports.buildChoiceValueId = exports.buildChoiceId = void 0;
var buildChoiceId = exports.buildChoiceId = function buildChoiceId(id) {
  return "Choice_".concat(id);
};
var buildChoiceValueId = exports.buildChoiceValueId = function buildChoiceValueId(id) {
  return "Choice_Value_".concat(id);
};
var buildOptionId = exports.buildOptionId = function buildOptionId(id) {
  return "Option_".concat(id);
};
var buildOptionHeaderId = exports.buildOptionHeaderId = function buildOptionHeaderId(id) {
  return "Option_Header_".concat(id);
};
var buildOptionSummaryRowId = exports.buildOptionSummaryRowId = function buildOptionSummaryRowId(id) {
  return "Option_Summary_Row_".concat(id);
};
//# sourceMappingURL=idBuilder.js.map